import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { SaveStates } from '@infl-ts/ui-advocate-components';
import { AppAlertsContext } from '@infl-ts/ui-app-alerts';
import { useMutationMapper } from '@infl-ts/util-use-mutation-mapper';
import * as E from 'fp-ts/Either';
import * as Str from 'fp-ts/string';
import { useCallback, useContext } from 'react';
import * as alerts from '../../alerts';
import { useEditCommentOnPublic } from '../../mutations';
var Saving = SaveStates.Saving,
    Default = SaveStates.Default,
    Error = SaveStates.Error;

var useSaveComment = function useSaveComment(_ref) {
  var id = _ref.id,
      onEditSaved = _ref.onEditSaved;

  var _useContext = useContext(AppAlertsContext),
      showAlert = _useContext.showAlert;

  var _useEditCommentOnPubl = useEditCommentOnPublic({
    onCompleted: E.match(function () {
      return showAlert(alerts.unableToEdit());
    }, function (_ref2) {
      var editCommentOnPublicResponse = _ref2.editCommentOnPublicResponse;
      return editCommentOnPublicResponse.__typename === 'CommentOnPublicResponseErrors' ? showAlert(alerts.unableToEdit(editCommentOnPublicResponse.errors[0].message)) : onEditSaved();
    })
  }),
      _useEditCommentOnPubl2 = _slicedToArray(_useEditCommentOnPubl, 2),
      editCommentOnPublic = _useEditCommentOnPubl2[0],
      editMutationStatus = _useEditCommentOnPubl2[1];

  var saveEdit = useCallback(function (message, onError) {
    return Str.isEmpty(message) ? onError() : void editCommentOnPublic({
      variables: {
        input: {
          id: id,
          body: message
        }
      }
    });
  }, [editCommentOnPublic, id]);
  var saveEditStatus = useMutationMapper(editMutationStatus, function (_ref3) {
    var response = _ref3.editCommentOnPublicResponse;
    return response.__typename === 'CommentOnPublicResponseErrors' ? E.left(response) : E.right(response);
  }, [Saving, Default, Error, Default]);
  return {
    saveEditStatus: saveEditStatus,
    saveEdit: saveEdit
  };
};

export default useSaveComment;